<template>
  <footer class="py-5 footer">
    <div class="container">
      <div class="row">
        <!--<div class="mx-auto mb-4 text-center col-lg-8">
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Company
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            About Us
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Team
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Products
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Blog
          </a>
          <a
            href="javascript:;"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Pricing
          </a>
        </div> -->
        <div class="mx-auto mt-2 mb-4 text-center col-lg-8">
          <a
            href="javascript:;"
            target="#"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-dribbble"></span>
          </a>
          <a
            href="javascript:;"
            target="#"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-twitter"></span>
          </a>
          <a
            href="javascript:;"
            target="#"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-instagram"></span>
          </a>
          <a
            href="javascript:;"
            target="#"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-pinterest"></span>
          </a>
          <a
            href="javascript:;"
            target="#"
            class="text-secondary me-xl-4 me-4"
          >
            <span class="text-lg fab fa-github"></span>
          </a>
        </div>
      </div>
      <div class="row">
        <div class="mx-auto mt-1 text-center col-8">
          <p class="mb-0 text-secondary">
            Copyright © {{ new Date().getFullYear() }} Soft by CloudChain Co. Ltd.
          </p>
          <div v-if="icpNumber">
            <br/>
            <span class="text-muted" style="color: #d3d3d3;left:10px">
              <a :href="icpUrl" style="color: #d3d3d3;">
                {{ icpNumber }}
              </a>
            </span>
          </div>
          <div v-if="copyright" style="margin-top: 4px;">
            <span class="text-muted" style="color: #d3d3d3; font-size: 13px;">
              {{ copyright }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getICPInfo } from "@/api/main.js";

export default {
  name: "app-footer",
  data() {
    return {
      icpNumber: "",
      icpUrl: "https://beian.miit.gov.cn",
      copyright: "",
    };
  },
  mounted() {
    this.fetchICPInfo();
  },
  methods: {
    async fetchICPInfo() {
      try {
        const res = await getICPInfo();
        if (res.code === 0 && res.desc) {
          this.icpNumber = res.desc.icp_number || "";
          this.icpUrl = res.desc.icp_url || "https://beian.miit.gov.cn";
          this.copyright = res.desc.copyright || "";
        }
      } catch {
        // 后端不可用时默认不显示
      }
    },
  },
};
</script>
